import React from 'react';
import { RadioButtonSelectField } from '../RadioButtonSelectField';
const BooleanSwitch = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
];
export const BooleanRadioButtonField = (props) => {
    return React.createElement(RadioButtonSelectField, Object.assign({ options: BooleanSwitch, coerceToBoolean: true }, props));
};
//# sourceMappingURL=BooleanRadioButtonField.js.map